<template>
    <v-card class="settings-card">
        <v-card-title><v-icon left>mdi-filter-variant</v-icon>فیلتر و جستجو</v-card-title>
        <v-card-text>
            <v-row dense>
                <v-col cols="12" sm="6" md="3" xl="2" v-for="(filter, index) in filters" :key="index">
                    <v-text-field v-if="filter.type === 'text'"
                                  v-model="values[filter.name]"
                                  :label="filter.label"
                                  color="#00ADB5" outlined dense hide-details>
                    </v-text-field>

                    <v-select v-else-if="filter.type === 'select'"
                              v-model="values[filter.name]"
                              :label="filter.label"
                              :item-text="filter.select_text"
                              :item-value="filter.select_value"
                              :items="filter.select_items"
                              color="#00ADB5" outlined dense hide-details clearable>
                    </v-select>

                    <v-text-field v-else-if="filter.type === 'date'"
                                  class="custom-input"
                                  v-model="values[filter.name]"
                                  :label="filter.label" color="#00ADB5" outlined dense hide-details>
                    </v-text-field>
                    <date-picker v-if="filter.type === 'date'" v-model="values[filter.name]"
                                 format="YYYY-MM-DD"
                                 color="#00ADB5"
                                 display-format="jYYYY-jMM-jDD"
                                 custom-input=".custom-input">
                        <template #month-name="{ date }" >
                            <span style="color: black!important;">{{ date.xFormat('jMMMM') }}</span>
                        </template>

                        <template #weekday="{ day }">
                            <span style="color: black">{{ day }}</span>
                        </template>

                        <template #day-item="{ day, color }">
                            <span class="vpd-day-effect" :style="{ 'background-color': color }" />
                            <span style="color: black" class="vpd-day-text" v-text="day.formatted" />
                        </template>
                    </date-picker>
                </v-col>
            </v-row>
            <div class="form-actions mt-4">
                <v-btn class="btn-secondary" outlined @click="reset">
                    <v-icon left>mdi-refresh</v-icon>
                    پاک کردن
                </v-btn>
                <v-btn class="btn-primary" depressed @click="search">
                    <v-icon left>mdi-magnify</v-icon>
                    اعمال فیلتر
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
    name: "SearchFilter",

    components: {
        datePicker: VuePersianDatetimePicker
    },

    props: [
        'filters'
    ],

    data() {
        return {
            values: {}
        }
    },

    methods: {
        search() {
            this.$emit("search", this.values)
        },

        reset() {
            this.values = {}
            this.$emit("search", this.values)
        },
    },
}
</script>

<style scoped>
</style>